import * as apiCommon from '@/api/apiCommon'

// 飞行员交通指引
const apiName = '/webapi/guide'

// 获取
export function read(data) {
	return apiCommon.index(apiName + '/read', data)
}